// Утилита для управления логированием
class Logger {
    constructor() {
        // Измените эту переменную для управления логами
        this.isEnabled = true; // false = только ошибки, true = все логи
        this.originalConsole = {
            log: console.log,
            info: console.info,
            warn: console.warn,
            error: console.error
        };
        
        this.setupLogging();
    }

    setupLogging() {
        if (!this.isEnabled) {
            // Отключаем информационные логи
            console.log = () => {};
            console.info = () => {};
            console.warn = () => {};

            // Оставляем только ошибки
            console.error = this.originalConsole.error;
        }
    }

    enable() {
        this.isEnabled = true;
        console.log = this.originalConsole.log;
        console.info = this.originalConsole.info;
        console.warn = this.originalConsole.warn;
        console.error = this.originalConsole.error;
    }

    disable() {
        this.isEnabled = false;
        console.log = () => {};
        console.info = () => {};
        console.warn = () => {};
        console.error = this.originalConsole.error;
    }

    // Методы для условного логирования
    log(...args) {
        if (this.isEnabled) {
            this.originalConsole.log(...args);
        }
    }

    info(...args) {
        if (this.isEnabled) {
            this.originalConsole.info(...args);
        }
    }

    warn(...args) {
        if (this.isEnabled) {
            this.originalConsole.warn(...args);
        }
    }

    error(...args) {
        // Ошибки всегда логируются
        this.originalConsole.error(...args);
    }

    // Метод для временного включения логов
    tempEnable(callback) {
        const wasEnabled = this.isEnabled;
        this.enable();
        try {
            callback();
        } finally {
            if (!wasEnabled) {
                this.disable();
            }
        }
    }
}

// Создаем глобальный экземпляр
export const logger = new Logger();

// Экспортируем методы для удобства
export const { log, info, warn, error, enable, disable, tempEnable } = logger;

// Глобальная функция для переключения логов (для отладки)
if (typeof window !== 'undefined') {
    window.toggleLogs = () => {
        if (logger.isEnabled) {
            logger.disable();
            console.log('🔇 Логи отключены');
        } else {
            logger.enable();
            console.log('🔊 Логи включены');
        }
    };
} 
